import React, { useMemo } from "react";
import { useShindan } from "../../hooks/use-shindan";
import { motion, Variants } from "framer-motion";
// @ts-ignore
import nl2br from "nl2br";

export type QuestionProps = Pick<
  ReturnType<typeof useShindan>,
  "question" | "handleNext"
>;

const questionVariants: Variants = {
  visible: {
    scale: 1,
    opacity: 1,
  },
  hidden: {
    scale: 0.6,
    opacity: 0,
  },
  exit: {
    opacity: 0,
  },
};

const answerVariants: Variants = {
  visible: (i) => {
    return {
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.3 + 0.5,
      },
      transitionEnd: {
        pointerEvents: "auto",
      },
    };
  },
  hidden: {
    opacity: 0,
    y: 10,
    pointerEvents: "none",
  },
  exit: {
    opacity: 0,
    y: -10,
    pointerEvents: "none",
  },
};

export const Question: React.FC<QuestionProps> = ({ question, handleNext }) => {
  const formattedQuestion = useMemo(() => {
    if (!question) return;

    let text = question.question;
    for (const a of question.answers) {
      text = text.replace(a.text, `<span>${a.text}</span>`);
    }
    return nl2br(text);
  }, [question]);

  if (!question) return null;

  return (
    <motion.div
      initial="hidden"
      animate="visible"
      exit="exit"
      className="shindan-app__question"
    >
      <motion.div
        variants={questionVariants}
        transition={{ type: "spring", duration: 0.5 }}
      >
        <div className="shindan-app__category">
          <span className="shindan-app__category__number">
            Q{question.number}.
          </span>
          <span className="shindan-app__category__main">
            {question.category}
          </span>
        </div>

        {formattedQuestion && (
          <p
            className="shindan-app__question__text"
            dangerouslySetInnerHTML={{ __html: formattedQuestion }}
          />
        )}
      </motion.div>

      <div className="shindan-app__answer">
        {question.answers.map((a, i) => {
          return (
            <motion.button
              custom={i}
              key={`${question.category}${question.number}${a.text}`}
              className="button button--primary shindan-app__answer__button"
              onClick={() => handleNext(a.points)}
              variants={answerVariants}
              transition={{ type: "spring", duration: 0.5 }}
            >
              {a.text}
            </motion.button>
          );
        })}
      </div>
    </motion.div>
  );
};
